import React from "react";
import { __ } from "../../../../../lib/translate";
import useWindowDimensions from "../../../../../lib/hooks/useWindowDimensions";
import { MOBILE_WIDTH_BREAKPOINT } from "../../../../../config/constants";
import EmptyDesktopIcon from "../../../../../../root/img/grid/empty-state/artists-desktop.svg";
import EmptyMobileIcon from "../../../../../../root/img/grid/empty-state/artists-mobile.svg";
import {
    EmptyStateMessage,
    EmptyStateMessageSubTitle,
    EmptyStateMessageTitle,
    EmptyStateWrapper,
    ImageContainer
} from "../styles";
import styled from "styled-components";

const Artists = ({ noItemsLabel }) => {
    const { bodyWidth } = useWindowDimensions();
    const isMobile = bodyWidth < MOBILE_WIDTH_BREAKPOINT;

    return (
        <EmptyStateWrapper $isMobile={isMobile}>
            <EmptyStateMessage $isMobile={isMobile}>
                <EmptyStateMessageTitle>
                    {__(...noItemsLabel)}
                </EmptyStateMessageTitle>
                <EmptyStateMessageSubTitleCustom>
                    {__(
                        "artists_empty_message",
                        "There are no artists to show."
                    )}
                </EmptyStateMessageSubTitleCustom>
            </EmptyStateMessage>

            <ImageContainer $isMobile={isMobile}>
                {!isMobile && <EmptyDesktopIcon />}
                {isMobile && <EmptyMobileIcon />}
            </ImageContainer>

            <div />
        </EmptyStateWrapper>
    );
};

export default Artists;

const EmptyStateMessageSubTitleCustom = styled(EmptyStateMessageSubTitle)`
    padding: 16px 0;
`;